module.exports = __webpack_public_path__ + "static/media/htmlIcon.0ef099b9.svg";